/**
 * Distância de Levenshtein entre duas strings — usada pra "fuzzy match" de
 * texto livre (ex.: nome de bairro/cidade digitado ou extraído por IA) contra
 * opções reais já cadastradas no banco. Quanto menor a distância, mais
 * parecidas as strings.
 *
 * Extraído de EmpreendimentoFormBasico.tsx (onde já era usado no autofill de
 * CEP) pra ser reaproveitado também na importação de empreendimento via IA.
 */
export const levenshteinDistance = (a: string, b: string): number => {
  if (!a || !b) return Number.MAX_SAFE_INTEGER;
  const matrix: number[][] = Array.from({ length: b.length + 1 }, () =>
    Array(a.length + 1).fill(0)
  );
  for (let i = 0; i <= b.length; i++) matrix[i][0] = i;
  for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      matrix[i][j] =
        b[i - 1] === a[j - 1]
          ? matrix[i - 1][j - 1]
          : Math.min(
              matrix[i - 1][j - 1] + 1,
              matrix[i][j - 1] + 1,
              matrix[i - 1][j] + 1
            );
    }
  }
  return matrix[b.length][a.length];
};
